import React, {Component} from 'react';

import withWindowResize from '../../ui/components/window-resize';

import '../css/pdp-genesys-chat.less';

class GenesysChat extends Component {
    constructor() {
        super();
    }

    openWindow = (e) => {
       const {device} = this.props;
       const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
       const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
       const left = (window.screen.width/2)-(312/2) + dualScreenLeft;
       const top = (window.screen.height/2)-(450/2) + dualScreenTop;
      e.preventDefault();
      device == "desktop" ? document.querySelector("#concierge li button[aria-label='Chat Now']").click() 
      : window.open('https://store.hp.com/app/static/js/genesys-popup.html', 'targetWindow', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=312, height=450, top='+top+', left='+left).focus();
    }

    componentDidMount() {
        var lp = document.querySelector(".lp_link");
        if (lp !== undefined) {
            lp.innerHTML="";
            lp.style.display="none";
        }
        var lp2 = document.querySelector(".live_help_list li");
        var elem = document.createElement("a");
        elem.innerHTML="Chat with a sales rep";
        if (lp2 !== undefined) {
            lp2.appendChild(elem);
            elem.href="javascript:void(0)";
        }
        elem.onclick=this.openWindow;
        

    }

    render() {
        return (
            <div className="genesysPopup">            
              <a id="genlink" href="" onClick={this.openWindow}>&nbsp;</a>               
            </div>
        )
    }
}

export default withWindowResize(GenesysChat);